import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Breadcrumb as AntBreadcrumb,
  Typography,
} from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const { Text, Title } = Typography;

const Breadcrumb = ({
  isMobile,
  routes,
}) => {
  const location = useLocation();
  const entidad = useSelector(({ auth }) => auth.entidad);
  const user = useSelector(({ auth }) => auth.user);

  const findNestedRoute = (path, _routes = routes) => (
    // eslint-disable-next-line
    _routes.reduce((a, route) => {
      if (a) return a;
      if (route.path === path) return route;
      if (route.children) return findNestedRoute(path, route.children);
    }, null)
  );

  const getTitleOfRoute = (path) => findNestedRoute(path)?.title || '';

  const titles = useMemo(() => {
    let paths = location.pathname.split('/').filter((x) => x.length).map((e) => `/${e}`);
    paths = paths.map((s, is) => `${paths.filter((a, i) => i <= is).join('')}`);
    const _titles = paths.map((path) => getTitleOfRoute(path));
    return _titles;
  }, [routes, location]);

  return (
    <Row
      className="breadcrumb"
      align="middle"
      justify="space-between"
      style={{
        marginBottom: 10,
        height: 44,
      }}
    >
      {(isMobile || location.pathname.length <= 40) && (
        <Title
          level={4}
          className="breadbrumb-title primary-text"
          style={{ margin: 0 }}
        >
          {location.pathname === '/dashboard' ? (
            <>
              <Text className="primary-text">
                Dashboard
              </Text>
              <br />
              {entidad.razon_social && (
                <Text style={{ fontSize: 14 }}>
                  {`Entidad: ${entidad.razon_social}`}
                </Text>
              )}
            </>
          ) : titles.at(-1)}
        </Title>
      )}
      {location.pathname.includes('/dashboard') ? (
        <Text style={{ fontSize: 18 }} className="primary-text">
          {`Bienvenido ${user?.first_name?.split(' ').shift()} !!`}
        </Text>
      ) : (
        <AntBreadcrumb style={{ marginLeft: 'auto' }}>
          {titles.map((title) => (
            <AntBreadcrumb.Item key={title}>
              {title}
            </AntBreadcrumb.Item>
          ))}
        </AntBreadcrumb>
      )}
    </Row>
  );
};

Breadcrumb.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isMobile: PropTypes.bool,
};

Breadcrumb.defaultProps = {
  isMobile: false,
};

export default Breadcrumb;
